import { useMutation } from '@tanstack/react-query';

import { logger } from '@/utils/logger/logger';
import { postEvidenceSBSSkip, type EvidenceSBSSkipRequest } from '../api';
import type { EvidenceSBSSkipResponse } from '../types';

export const SKIP_EVIDENCE_SBS_KEY = 'SKIP_EVIDENCE_SBS';

export function useSkipEvidenceSBSMutation() {
  return useMutation<EvidenceSBSSkipResponse, Error, { reqBody: EvidenceSBSSkipRequest }>(
    {
      mutationKey: [SKIP_EVIDENCE_SBS_KEY],
      mutationFn: async ({ reqBody }) => {
        const response = await postEvidenceSBSSkip(reqBody);
        if (!response.data.success) {
          throw new Error('Evidence SBS skip returned success: false');
        }
        return response.data;
      },
      onError(err) {
        // Best-effort: a skip API failure only means the user may see SBS again
        // on the next message — it does not affect dismiss UX (overlay is
        // already gone by the time this resolves). Log and move on.
        logger.error('[EVIDENCE_SBS] skip failed', err);
      },
    }
  );
}
